import { formatCustomerUsdPrice } from "../commerce/customerPriceDisplay";

export const customerCartUpdatedEventName = "vintera:customer-cart-updated";

export type CustomerCartIndicatorInput = {
  items: readonly unknown[];
  estimated_subtotal: string | null;
  estimated_currency_code: string | null;
};

export type CustomerCartIndicator = {
  itemCount: number;
  totalLabel: string | null;
};

export function getCustomerCartIndicator(cart: CustomerCartIndicatorInput): CustomerCartIndicator {
  const itemCount = cart.items.length;
  return {
    itemCount,
    totalLabel: itemCount > 0
      ? formatCustomerUsdPrice(cart.estimated_subtotal, cart.estimated_currency_code)
      : null,
  };
}

export function announceCustomerCartUpdated(cart?: CustomerCartIndicatorInput) {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(customerCartUpdatedEventName, { detail: cart }));
  }
}
